export default __webpack_public_path__ + "static/media/Res_Amazon-Simple-Storage_Bucket-With-Objects_48_Light.ef490df4.svg";